import { createApiCall } from 'lib/base';

const RESET_STAFF_ACCOUNT_PASSWORD = 'RESET_STAFF_ACCOUNT_PASSWORD';

export const resetStaffAccountPasswordApi = createApiCall<{
  id: string;
  payload: { password: string };
}>(RESET_STAFF_ACCOUNT_PASSWORD, ({ id, payload }) => ({
  endpoint: `api/admin/staff-accounts/${id}/reset-password`,
  method: 'POST',
  body: payload,
}));

export default resetStaffAccountPasswordApi;
